import { render, staticRenderFns } from "./prestamoFilters.vue?vue&type=template&id=299a4a8f"
import script from "./prestamoFilters.vue?vue&type=script&lang=js"
export * from "./prestamoFilters.vue?vue&type=script&lang=js"
import style0 from "./prestamoFilters.vue?vue&type=style&index=0&id=299a4a8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports